// Material
import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { ReplaceIcon } from '$common/icons/replace'
import { t } from '$i18n'

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.main,
  border: 'none',
  padding: '5px 0',
  minWidth: '107px',
  ...theme.typography.messageBold,
  marginRight: '30px',
  '.MuiButton-startIcon': {
    marginLeft: 4,
    marginRight: 0,
  },
  ':hover': {
    border: 'none',
    backgroundColor: 'unset',
  },
}))

interface prop {
  onClick: () => any
  text?: string
}
export function ReplaceButton({ text, onClick }: prop) {
  return (
    <StyledButton
      variant="outlined"
      startIcon={<ReplaceIcon />}
      onClick={onClick}
    >
      {text || t('chat.replaceFile')}
    </StyledButton>
  )
}

ReplaceButton.defaultProps = {
  text: '',
}
